<template>
  <div class="page-container">
    <div class="page-content">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white">
            <i class="mdi mdi-gavel"></i> Apoio Jurídico
          </h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <button
              v-if="$can('process-import')"
              @click="openImportProcessesModal()"
              class="btn btn-outline-white"
            >
              <i class="far fa-file-excel"></i>
              <span class="d-none d-md-inline-block ml-2"
                >Importar Documento</span
              >
            </button>
          </div>
        </div>
        <div v-if="last_import" class="d-block text-white text-right mb-2">
          <small v-html="MsgLastImport"></small>
        </div>
      </div>

      <!-- Alerta -->
      <div v-if="alertMessage" class="col-12">
        <b-alert show variant="danger">{{ alertMessage }}</b-alert>
      </div>

      <!-- Overlay de Loading -->
      <div
        v-if="loading"
        class="overlay-modal d-flex align-items-center justify-content-center"
      >
        <b-spinner label="Carregando..."></b-spinner>
      </div>

      <!-- Corpo -->
      <div class="page-body">
        <div class="card bg-light-gray">
          <div class="card-body pt-1">
            <!-- Tabela -->
            <div class="table-responsive">
              <table
                class="table-v3"
                role="table"
                aria-busy="false"
                aria-colcount="6"
              >
                <thead role="rowgroup">
                  <tr role="row">
                    <th class="nowrap">Número do Processo</th>
                    <th class="nowrap">Partes Polo Ativo</th>
                    <th class="nowrap">Pedido Substituição</th>
                    <th class="nowrap">Tipo Recurso</th>
                    <th class="nowrap">Valor Depósito</th>
                    <th class="nowrap text-center">Ação</th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <tr v-for="item in paginatedItems" :key="item.id" role="row">
                    <td class="font-12">{{ item.number }}</td>
                    <td class="font-12">{{ item.active_part }}</td>
                    <td class="font-12">{{ item.substitution_order }}</td>
                    <td class="font-12">{{ item.resource_types }}</td>
                    <td class="font-12">
                      {{ formatCurrency(item.value_deposit) }}
                    </td>
                    <td class="column-size-share font-12 text-center">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <button
                          v-if="$can('process-show')"
                          class="btn btn-action"
                          @click="
                            redirect('details-process', { processId: item.id })
                          "
                          title="Visualizar"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                        <button
                          v-if="$can('process-delete')"
                          class="btn btn-action"
                          @click="showModalDestroy(item)"
                          title="Apagar"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Import Processes Modal -->
            <ImportProcessesModal
              v-model="showImportProcessModal"
              @processesImported="getProcesses"
            />

            <!-- Paginação -->
                 <nav aria-label="Paginação">
          <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
          ></b-pagination>
        </nav>
          </div>
        </div>
      </div>

      <!-- Modal de Exclusão -->
      <b-modal
        id="show-modal"
        ref="showModal"
        size="md"
        class="mt-4"
        hide-footer
        centered
      >
        <template #modal-title>Excluir processo</template>
        <div class="card p-3 mb-3">
          <p class="mb-0">{{ deletion_data }}</p>
        </div>
        <div class="d-flex justify-content-end">
          <button
            @click="$bvModal.hide('show-modal')"
            class="btn btn-outline-secondary mr-2"
          >
            <i class="fa fa-angle-left mr-1"></i> Voltar
          </button>
          <button
            v-if="$can('process-delete')"
            @click="destroyProcess()"
            class="btn btn-primary"
          >
            Excluir <i class="fa fa-angle-right ml-1"></i>
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import jurimetryService from "@/services/jurimetry";
import numericFormatterMixin from "@/mixins/numericFormatter";
import uiHelperMixin from "@/mixins/uiHelper";
import dateFormatter from "@/mixins/dateFormatter";
import ImportProcessesModal from "@/components/Jurimetry/ImportProcesses/Index.vue";

export default {
  name: "list-jurimetries",
  components: { ImportProcessesModal },
  mixins: [numericFormatterMixin, dateFormatter, uiHelperMixin],
  data: () => ({
    perPage: 10,
    currentPage: 1,
    items: [],
    deletion_data: "",
    current_deletion: null,
    showImportProcessModal: false,
    last_import: null,
    loading: false,
  }),
  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.perPage) || 1;
    },
    pages() {
      // até 3 páginas: anterior, atual, próxima
      let start = Math.max(1, this.currentPage - 1);
      let end = Math.min(this.totalPages, start + 2);
      if (end - start < 2) start = Math.max(1, end - 2);
      const arr = [];
      for (let p = start; p <= end; p++) arr.push(p);
      return arr;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.items.slice(start, start + this.perPage);
    },
    MsgLastImport() {
      return this.last_import
        ? `Último processo importado em <strong>${this.last_import.toLocaleDateString(
            "pt-BR"
          )}</strong>`
        : "-";
    },
  },
  created() {
    this.getProcesses();
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    getProcesses() {
      this.resetAlert();
      this.loading = true;
      jurimetryService
        .getProcesses()
        .then((res) => {
          if (res.data.error) {
            this.showError(res.data.message);
            return;
          }
          this.items = res.data;
          this.last_import = this.getLastCreatedDate(this.items);
        })
        .catch(() => {
          this.showError("Não foi possível recuperar os processos.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirect(routeName, params = null) {
      this.$router.push({ name: routeName, params });
    },
    openImportProcessesModal() {
      this.showImportProcessModal = true;
    },
    openFilterModal() {
      this.$refs.filterModal.show();
    },
    clearFilters() {
      this.getProcesses();
    },
    showModalDestroy(item) {
      this.current_deletion = item.id;
      this.deletion_data = `Deseja realmente excluir o processo ${item.number}?`;
      this.$refs.showModal.show();
    },
    destroyProcess() {
      this.loading = true;
      jurimetryService
        .destroyProcess(this.current_deletion)
        .then((res) => {
          if (res.data.error) {
            this.showError(res.data.message);
            return;
          }
          this.getProcesses();
        })
        .catch(() => {
          this.showError("Não foi possível remover este processo.");
        })
        .finally(() => {
          this.loading = false;
          this.$bvModal.hide("show-modal");
        });
    },
  },
};
</script>

<style scoped>
</style>
